import {
  Layout as RALayout,
  Sidebar as RASidebar,
  MenuItemLink,
  DashboardMenuItem,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import PeopleIcon from "@material-ui/icons/PeopleOutline";
import TanksIcon from "@material-ui/icons/BatteryChargingFullOutlined";
import BrandsIcon from "@material-ui/icons/ViewListOutlined";
import PlacesIcon from "@material-ui/icons/PlaceOutlined";
import ProductIcon from "@material-ui/icons/StorefrontOutlined";
import ProductOrderIcon from "@material-ui/icons/LocalShippingOutlined";
import TransferIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import ContactIcon from "@material-ui/icons/ContactMailOutlined";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import CustomAppBar from "../CustomAppBar";

const Sidebar = (props) => {
  const useSidebarStyles = makeStyles({
    drawerPaper: {
      //   backgroundColor: "red",
    },
  });
  const classes = useSidebarStyles();
  return <RASidebar classes={classes} {...props}></RASidebar>;
};

const Menu = (props) => {
  return (
    <div style={styles.MenuContainer}>
      {/* <MenuItemLink
        to="/"
        primaryText="Dashboard"
        leftIcon={<DashboardIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
        exact
      /> */}
      <MenuItemLink
        to="/dashboard"
        primaryText="Dashboard"
        leftIcon={<DashboardIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/users"
        primaryText="Users"
        leftIcon={<PeopleIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/tanks"
        primaryText="Tanks"
        leftIcon={<TanksIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/places"
        primaryText="Places"
        leftIcon={<PlacesIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/brands"
        primaryText="Brands"
        leftIcon={<BrandsIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      {/* <MenuItemLink to="/brands" primaryText="Orders" leftIcon={<BookIcon />} /> */}
      <MenuItemLink
        to="/products"
        primaryText="Products"
        leftIcon={<ProductIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/productOrders"
        primaryText="Product Orders"
        leftIcon={<ProductOrderIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/transferOrders"
        primaryText="Transfer Orders"
        leftIcon={<TransferIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/contactMessages"
        primaryText="Contact Messages"
        leftIcon={<ContactIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
      <MenuItemLink
        to="/settings"
        primaryText="System Settings"
        leftIcon={<SettingsIcon style={styles.MenuItemIcon} />}
        style={styles.MenuItemContainer}
        activeStyle={styles.MenuItemContainerActive}
      />
    </div>
  );
};

const Layout = (props) => (
  <RALayout {...props} appBar={CustomAppBar} sidebar={Sidebar} menu={Menu} />
);

export default Layout;

const styles = {
  MenuContainer: {
    backgroundColor: "#262626",
    minHeight: "100%",
    padding: 0,
    paddingTop: 20,
  },
  MenuItemContainer: { color: "#fff", marginBottom: 20 },
  MenuItemContainerActive: {
    backgroundColor: "#EEBC1D",
  },
  MenuItemIcon: { color: "#fff" },
};
